import agencyApi from 'api/agencyApi';
import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import ChargeHelper from 'features/Charge/chargeHelper';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import DropdownFilterTable from 'general/components/DropdownFilterTable';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSButton, {
    KTBSButtonColor,
    KTBSButtonSize,
} from 'general/components/OtherKeenComponents/KTBSButton';
import KTBSCard from 'general/components/OtherKeenComponents/KTBSCard';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
    KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDateRangePicker, { dateFilter, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';
import EmptyView from 'general/components/Others/EmptyView';
import MenuActionDropdown from 'general/components/Others/MenuActionDropdown';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Global from 'general/utils/Global';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import * as ExcelJS from 'exceljs';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import AgencyHelper from 'features/Agency/agencyHelper';

const defaultColumnIds = [
    'CODE',
    'NAME',
    'TYPE',
    'PARENT_PARTNER',
    'PHONE',
    'EMAIL',
    'MST/CCCD',
    'TOTAL_SALE',
    'TOTAL_POINT',
    'AMOUNT',
    'STATUS',
    'COUNTRY',
    'ADDRESS',
    'CREATEDBY',
    'DATE',
];

function ChargePointPartnerListScreen(props) {
    // ---- params ----
    const { t } = useTranslation();
    const router = useRouter();
    const [operatorList, setOperatorList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [filter, setFilter] = useState(Global.g_filterChargePointPartnerList);
    const [filterDropdown, setFilterDropdown] = useState(Global.g_filterChargePointPartnerList);

    // khu vuc
    const areaTree = useSelector((state) => state.app.areaTree);
    const areaProvinceList = useMemo(() => {
        return ChargeHelper.Utils.getAreaListByType([areaTree], 'P');
    }, [areaTree]);
    const areaProvinceOptions = useMemo(() => {
        return _.map(areaProvinceList, (item) => {
            return {
                name: item.name,
                value: item.areaId,
            };
        });
    }, [areaProvinceList]);
    const [selectedAreaProvince, setSelectedAreaProvince] = useState();
    const areaDistrictList = useMemo(() => {
        if (!selectedAreaProvince) return [];
        return ChargeHelper.Utils.getSubAreaListByParentId([areaTree], selectedAreaProvince?.areaId);
    }, [areaTree, selectedAreaProvince]);
    const areaDistrictOptions = useMemo(() => {
        return _.map(areaDistrictList, (item) => {
            return {
                name: item.name,
                value: item.areaId,
            };
        });
    }, [areaDistrictList]);
    const [selectedAreaDistrict, setSelectedAreaDistrict] = useState();
    useEffect(() => {
        const areaId = filterDropdown.areaId;
        if (Utils.isValid(areaId)) {
            const area = ChargeHelper.Utils.getAreaById([areaTree], areaId);
            if (area?.typeCode === 'P') {
                setSelectedAreaProvince(area);
            } else {
                setSelectedAreaDistrict(area);
                const parentAreaId = area?.parentId;
                if (Utils.isValid(parentAreaId)) {
                    setSelectedAreaProvince(ChargeHelper.Utils.getAreaById([areaTree], parentAreaId));
                }
            }
        }
    }, [filterDropdown?.areaId, areaTree]);

    const app = useSelector((state) => state.app);
    const { user } = useSelector((state) => state.auth);
    const { isGettingData, chargePointPartnerList, chargePointPartnerTotal } = useSelector((state) => state.agency);
    const adminRole =
        user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;

    const fullColumns = useMemo(() => {
        return [
            {
                id: 'CODE',
                sortable: false,
                name: UIHelper.buildTableColumn('Mã đối tác'),
                width: '120px',
                selector: (row) => row?.agencyCode ?? row.agencyId,
                style: tableStyle.columns.normal,
            },
            {
                id: 'NAME',
                sortable: false,
                name: UIHelper.buildTableColumn('Tên đối tác'),
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row.name ?? ''}>
                            <span>{row.name ?? ''}</span>
                        </KTTooltip>
                    );
                },
                minWidth: '240px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'TYPE',
                sortable: false,
                name: UIHelper.buildTableColumn('Loại đối tác'),
                selector: (row) => t(row.type),
                width: '120px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'PARENT_PARTNER',
                sortable: false,
                name: UIHelper.buildTableColumn('Người quản lý'),
                selector: (row) => (
                    <KTTooltip offset={[0, 0]} text={row?.parentAgency?.name}>
                        <span
                            className="cursor-pointer hover-opacity-60"
                            onClick={() => {
                                DealerHelper.navigateToParentAgency(row?.parentAgency);
                            }}
                        >
                            {row?.parentAgency?.name}
                        </span>
                    </KTTooltip>
                ),
                minWidth: '200px',
                style: tableStyle.columns.link,
            },
            {
                id: 'PHONE',
                sortable: false,
                name: UIHelper.buildTableColumn('Số điện thoại'),
                width: '140',
                selector: (row) => row.phone ?? '',
                style: tableStyle.columns.normal,
            },
            {
                id: 'EMAIL',
                sortable: false,
                name: UIHelper.buildTableColumn('Email'),
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row?.email ?? ''}>
                            <span>{row?.email ?? ''}</span>
                        </KTTooltip>
                    );
                },
                minWidth: '240px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'MST/CCCD',
                sortable: false,
                name: UIHelper.buildTableColumn('MST/CCCD'),
                width: '160px',
                selector: (row) => row.taxCode ?? '',
                style: tableStyle.columns.normal,
            },
            {
                id: 'TOTAL_SALE',
                name: UIHelper.buildTableColumn('Tổng số đơn hàng'),
                selector: (row) => Utils.formatNumber(row?.totalPurchases ?? 0),
                width: '150px',
                right: true,
                style: tableStyle.columns.normal,
                sortable: false,
            },
            {
                id: 'TOTAL_POINT',
                name: UIHelper.buildTableColumn('Số trụ sạc đã mua'),
                selector: (row) => Utils.formatNumber(row?.totalChargePointsPurchased ?? 0),
                width: '150px',
                right: true,
                style: tableStyle.columns.normal,
                sortable: false,
            },
            {
                id: 'AMOUNT',
                name: UIHelper.buildTableColumn('Tổng giá trị mua hàng', 'VNĐ'),
                selector: (row) => Utils.formatNumber(row?.totalAmountPurchased ?? 0),
                width: '170px',
                right: true,
                style: tableStyle.columns.normal,
                sortable: false,
            },
            {
                id: 'STATUS',
                sortable: false,
                name: UIHelper.buildTableColumn('Trạng thái'),
                minWidth: '150px',
                selector: (row) => {
                    return (
                        <KTLabel
                            text={t(`agencyStatus_${row.status}`)}
                            isInline={true}
                            size={KTLabelSize.medium}
                            additionalClassName={`label-light-${DealerHelper.getAgencyStatusColor(row.status)}`}
                        />
                    );
                },
            },
            {
                id: 'COUNTRY',
                name: UIHelper.buildTableColumn('Quốc gia'),
                selector: (row) => _.find(AgencyHelper.Data.CountryOptions, { value: row?.country })?.name,
                style: tableStyle.columns.normal,
                width: '150px',
            },
            {
                id: 'ADDRESS',
                sortable: false,
                name: UIHelper.buildTableColumn('Địa chỉ'),
                selector: (row) => {
                    const area = ChargeHelper.Utils.getAreaById([areaTree], row?.areaId);
                    let parentArea;
                    if (area?.typeCode === 'W') {
                        parentArea = ChargeHelper.Utils.getAreaById([areaTree], area?.parentId);
                    }
                    const addressResuslt = [
                        row.address,
                        area?.name,
                        parentArea?.name
                    ]
                        .filter(Boolean)
                        .join(', ');
                    return (
                        <KTTooltip text={addressResuslt} offset={[0, 0]}>
                            <span>{addressResuslt?.length > 0 ? addressResuslt : ''}</span>
                        </KTTooltip>
                    );
                },
                minWidth: '250px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'CREATEDBY',
                name: UIHelper.buildTableColumn('Người tạo'),
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row?.createdBy?.fullname ?? row?.name}>
                            <span
                                className="cursor-pointer hover-opacity-60"
                                onClick={() => {
                                    DealerHelper.navigateToParentAgency(row?.createdBy ?? row);
                                }}
                            >
                                {row?.createdBy?.fullname ?? row?.name}
                            </span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.link,
                sortable: false,
                width: '200px',
            },
            {
                id: 'DATE',
                sortable: false,
                name: UIHelper.buildTableColumn('Ngày tạo'),
                selector: (row) => row?.createdAt ? Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY - HH:mm') : '',
                style: tableStyle.columns.normal,
                minWidth: '180px',
            },
            {
                name: (
                    <span
                        className="letter-spacing-unset font-weight-bolder"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('actions')}
                    </span>
                ),
                width: '130px',
                wrap: true,
                style: {
                    position: 'sticky',
                    right: 0,
                    backgroundColor: '#fff',
                    borderLeft: '1px solid #ebedfe',
                },
                cell: (row) => {
                    return (
                        <MenuActionDropdown
                            menuAction={[
                                {
                                    iconElement: <i className="fa-regular fa-eye" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                    text: t('Xem chi tiết'),
                                    click: () => {
                                        handleClickedRow(row);
                                    },
                                    show: true,
                                },
                                {
                                    iconElement: <i className="fa-regular fa-bolt" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                    text: t('Kích hoạt tài khoản'),
                                    click: () => {
                                        DealerHelper.handleAcceptAgency(row, () => {
                                            getPartnerList(filter);
                                        });
                                    },
                                    show: row?.status === 'REGISTERED'
                                        && (adminRole ||
                                            DealerHelper.checkHasEditPermission(
                                                row,
                                                row?.parentAgency,
                                                user?.agency
                                            )),
                                },
                                {
                                    iconElement: <i className="fa-regular fa-pen-to-square" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                    text: t('edit'),
                                    click: () => {
                                        handleShowEditInvestor(row);
                                    },
                                    show: (!row?.numberOfSignedContracts
                                        && DealerHelper.checkHasEditPermission(
                                            row,
                                            row?.parentAgency,
                                            user?.agency
                                        )) || adminRole,
                                },
                                {
                                    iconElement: <i className="fa-regular fa-plus-circle" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                    text: t('addOrder'),
                                    click: () => {
                                        router.navigate(`add-order?chargepoint=${row?.agencyId}`);
                                    },
                                    show: row?.status === 'NORMAL'
                                        && (adminRole || DealerHelper.checkHasEditPermission(
                                            row,
                                            row?.parentAgency,
                                            user?.agency
                                        ))
                                        && user?.agency?.primaryRole === 'SALE',
                                },
                                {
                                    iconElement: <i className="far fa-square" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                    text: t('Ngừng hoạt động'),
                                    click: () => {
                                        DealerHelper.handleStopAgency(row, () => {
                                            getPartnerList(filter);
                                        });
                                    },
                                    show: row?.status === 'NORMAL'
                                        && (adminRole || DealerHelper.checkHasEditPermission(
                                            row,
                                            row?.parentAgency,
                                            user?.agency
                                        )),
                                },
                                {
                                    iconElement: <i className="far fa-play" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                    text: t('Khôi phục hoạt động'),
                                    click: () => {
                                        DealerHelper.handleActiveAgency(row, () => {
                                            getPartnerList(filter);
                                        });
                                    },
                                    show: row?.status === 'SUSPENDED'
                                        && (adminRole || DealerHelper.checkHasEditPermission(
                                            row,
                                            row?.parentAgency,
                                            user?.agency
                                        )),
                                },
                                // {
                                //     iconElement: (
                                //         <i
                                //             className="fa-regular fa-file-contract"
                                //             style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                //         ></i>
                                //     ),
                                //     text: 'Tạo hợp đồng CTV',
                                //     click: () => {
                                //         // AgencyHelper.UI.showDialogConfirmCreateContractWithSale(row, () => {});
                                //         AgencyHelper.UI.showDialogConfirmCreateContractWithAgency(row, () => { });
                                //     },
                                //     show:
                                //         !row?.numberOfSignedContracts &&
                                //         row?.status !== 'REGISTERED'
                                //         && adminRole
                                // },
                                // {
                                //     iconElement: <i className={`fa-regular fa-lock`} style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                //     text: t('Đặt lại mật khẩu'),
                                //     click: () => {
                                //         DealerHelper.showDialogChangePassword(row, () => {
                                //             getPartnerList(filter);
                                //         })
                                //     },
                                //     show: adminRole,
                                // },
                                {
                                    iconElement: <i className={`fa-regular fa-trash-can`} style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                    text: t('Xóa đối tác'),
                                    click: () => {
                                        DealerHelper.handleDeleteAgency(row, () => {
                                            getPartnerList(filter);
                                        });
                                    },
                                    show: !row?.numberOfSignedContracts
                                        && (adminRole || DealerHelper.checkHasEditPermission(
                                            row,
                                            row?.parentAgency,
                                            user?.agency
                                        )),
                                },
                            ]}
                        />
                    );
                },
            },
        ];
    }, [t, operatorList, areaTree, user, filter]);

    const prefKey = useMemo(() => {
        const userId = user.userId;
        const pathName = router.pathname;
        const key = `${userId}_${pathName}`;
        return key;
    }, [user, router]);
    const [fullColumnIds, setFullColumnIds] = useState(fullColumns?.map((row) => row?.id));
    const {
        columnIds,
        columns,
        onChangeCheckboxValue,
        saveChanges,
        resetDefaultTableColumn,
        onSelectAll,
        onUnSelectAll,
        fullColumnsSorted,
        fullColumnsIdSorted,
    } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

    useEffect(() => {
        if (app.areaTree) {
            classifyAreas(app.areaTree);
        }
    }, [app.areaTree]);
    const classifyAreas = (area) => {
        if (!area) return;

        if (area.parentId === 0) {
            setCityList([
                {
                    areaId: area.areaId,
                    name: area.name,
                    districtList: area.subAreas?.map((subArea) => ({
                        areaId: subArea.areaId,
                        name: subArea.name,
                    })),
                },
            ]);
        }
    };

    const classifyOperators = (operators) => {
        setOperatorList(
            operators?.map((operator) => ({ operatorId: operator.operatorId, name: operator.name }))
        );
    };

    useEffect(() => {
        if (app.appConfig) {
            classifyOperators(app.appConfig.operators ?? []);
        }
    }, [app.appConfig]);

    useEffect(() => {
        getPartnerList({ ...filter, parentAgencyId: adminRole ? '' : user?.agency?.agencyId });
    }, [filter]);

    const getPartnerList = () => {
        try {
            DealerHelper.callApiGetAgencyList(filter);
        } catch (error) {
            ToastHelper.showError(error?.response?.data?.reason);
        }
    };


    // ---- methods ----
    const handleClickedRow = (row) => {
        router.navigate(`${row.agencyId}`);
    };

    //them nha dau tu
    const handleOpenAddInvestorModal = () => {
        router.navigate('add');
    };

    // chinh sua nha dau tu
    const handleShowEditInvestor = (row) => {
        router.navigate(`${row?.agencyId}/edit`);
    };

    const updateFilter = (key, value) => {
        Global.g_filterChargePointPartnerList = { ...Global.g_filterChargePointPartnerList, [key]: value };
        setFilter(Global.g_filterChargePointPartnerList);
        setFilterDropdown(Global.g_filterChargePointPartnerList);
    };

    // xuat file excel
    const handleExportExcel = async (exportData, params) => {
        let exportDataList = exportData;
        if (_.isEmpty(exportDataList)) {
            ToastHelper.showError('Không có dữ liệu để tải xuống');
            return;
        }

        const sheetFileName = 'Danh_sách_đối_tác_mua_trụ_sạc_' + moment(params.from).format('DDMMYYYY') + '_' + moment(params.to).format('DDMMYYYY');
        const ext = '.xlsx';
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet(sheetFileName, {
            headerFooter: { firstHeader: sheetFileName },
        });

        sheet.mergeCells('A1:O1');
        sheet.getCell('A1').value = `DANH SÁCH ĐỐI TÁC MUA TRỤ SẠC (NGÀY ${moment(params.from).format(
            'DD/MM/YYYY'
        )} - ${moment(params.to).format('DD/MM/YYYY')})`;
        sheet.getCell('A1').font = {
            name: 'Times New Roman',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: 'FFFFFFFF' },
        };
        sheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        sheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '29618E' },
            color: { argb: 'FFFFFF' },
        };
        sheet.getCell('A1').border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };
        sheet.getRow(1).height = 25;

        const columns = [
            { key: 'stt', width: 7 },
            { key: 'agencyCode', width: 18 },
            { key: 'agencyName', width: 35 },
            { key: 'type', width: 18 },
            { key: 'parentAgency', width: 22 },
            { key: 'phone', width: 22 },
            { key: 'email', width: 30 },
            { key: 'cccd', width: 22 },
            { key: 'totalSale', width: 22 },
            { key: 'totalPoint', width: 22 },
            { key: 'amount', width: 22 },
            { key: 'status', width: 20 },
            { key: 'address', width: 35 },
            { key: 'createBy', width: 22 },
            { key: 'date', width: 22 },
        ];
        sheet.columns = columns;

        sheet.getRow(2).height = 30;
        sheet.getRow(2).font = {
            name: 'Times New Roman',
            family: 4,
            size: 11,
            bold: true,
        };
        sheet.getRow(2).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
        };

        sheet.getCell('A2').value = 'STT';
        sheet.getCell('B2').value = 'Mã NĐT';
        sheet.getCell('C2').value = 'Tên NĐT nhượng quyền';
        sheet.getCell('D2').value = 'Loại nhà đầu tư';
        sheet.getCell('E2').value = 'Đối tượng quản lý';
        sheet.getCell('F2').value = 'Số điện thoại';
        sheet.getCell('G2').value = 'Email';
        sheet.getCell('H2').value = 'MST/CCCD';
        sheet.getCell('I2').value = 'Tổng số đơn hàng';
        sheet.getCell('J2').value = 'Số trụ sạc đã mua';
        sheet.getCell('K2').value = 'Tổng giá trị mua hàng (VNĐ)';
        sheet.getCell('L2').value = 'Trạng thái';
        sheet.getCell('M2').value = 'Địa chỉ';
        sheet.getCell('N2').value = 'Người tạo';
        sheet.getCell('O2').value = 'Ngày tạo';


        ['A2:O2'].forEach((range) => {
            sheet.getRow(range.split(':')[0].slice(1)).eachCell({ includeEmpty: true }, (cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
            });
        });

        let i = 1;
        exportDataList?.forEach((row) => {
            // Dia chi
            const area = ChargeHelper.Utils.getAreaById([areaTree], row?.areaId);
            let parentArea;
            if (area?.typeCode === 'W') {
                parentArea = ChargeHelper.Utils.getAreaById([areaTree], area?.parentId);
            }
            const addressResuslt = [
                row.address,
                area?.name,
                parentArea?.name
            ]
                .filter(Boolean)
                .join(', ');

            const dataRow = sheet.addRow({
                stt: i++,
                agencyCode: row?.agencyCode ?? row.agencyId,
                agencyName: row?.name,
                type: t(row.type),
                parentAgency: row?.parentAgency?.name ?? '',
                phone: row.phone ?? '',
                email: row?.email ?? '',
                cccd: row.type === AppConstants.accountType.individual
                    ? row.idCardNumber?.length > 0
                        ? row.idCardNumber
                        : row.taxCode?.length > 0
                            ? row.taxCode
                            : ''
                    : row.taxCode?.length > 0
                        ? row.taxCode
                        : '',
                totalSale: '',
                totalPoint: '',
                amount: '',
                status: t(`agencyStatus_${row.status}`),
                address: addressResuslt?.length > 0 ? addressResuslt : '',
                createBy: row?.createdBy?.fullname ?? '',
                date: row?.createdAt ? Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY - HH:mm') : '',
            });

            dataRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
                if (colNumber === 1) {
                    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                } else if (colNumber >= 9 && colNumber <= 11) {
                    cell.alignment = { vertical: 'middle', horizontal: 'right', wrapText: true };
                } else {
                    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
                }
            });
        });

        sheet.eachRow((row, rowNumber) => {
            if (rowNumber >= 3) {
                row.font = {
                    name: 'Times New Roman',
                    family: 4,
                    size: 11,
                    bold: false,
                };
            }
        });

        workbook.xlsx.writeBuffer().then(function (data) {
            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = sheetFileName + ext;
            anchor.click();
            window.URL.revokeObjectURL(url);
            ToastHelper.showSuccess('Tải xuống file Excel thành công');
            AppCustomDialogHelper.hide();
        });
    };

    const FilterComponentList = ({ isInDropdown = false }) => (
        <div className={`${isInDropdown ? 'row' : 'w-100'} d-flex  flex-row  flex-wrap`}>
            {/* loai nha dau tu */}
            <KTDropdownFilter
                label={t('Loại đối tác')}
                filterKey="type"
                options={DealerHelper.filterAgencyTypeOptions()}
                selectedValue={!isInDropdown ? Global.g_filterChargePointPartnerList.type : filterDropdown.type}
                isInDropdown={isInDropdown}
                additionalClassName={`${isInDropdown ? 'pr-2 pt-4' : 'pl-0 pr-4'}`}
                handleChange={(value) => {
                    if (isInDropdown) {
                        setFilterDropdown({ ...filterDropdown, type: value });
                    } else {
                        updateFilter('type', value);
                        updateFilter('page', 0);
                    }
                }}
            />

            {!isInDropdown && !adminRole && (
                <KTDropdownFilter
                    label={t('Đối tượng quản lý')}
                    filterKey="deepLevel"
                    options={DealerHelper.filterLevelOptions('CHARGEPOINT', user?.agency?.deepLevel)}
                    selectedValue={filterDropdown.deepLevel}
                    isInDropdown={isInDropdown}
                    additionalClassName="pr-4"
                    handleChange={(value) => {
                        if (isInDropdown) {
                            setFilterDropdown({ ...filterDropdown, deepLevel: value });
                        } else {
                            updateFilter('deepLevel', value);
                        }
                    }}
                />
            )}

            {/* trang thai */}
            <KTDropdownFilter
                label={t('status')}
                filterKey="status"
                options={DealerHelper.filterStatusOptions()}
                selectedValue={
                    !isInDropdown
                        ? Global.g_filterChargePointPartnerList.status ||
                        (Global.g_filterChargePointPartnerList.hasSignedContract ? AppConstants.agencyStatus.signed : '')
                        : filterDropdown.status ||
                        (Global.g_filterChargePointPartnerList.hasSignedContract || filterDropdown.hasSignedContract ? AppConstants.agencyStatus.signed : '')
                }
                isInDropdown={isInDropdown}
                additionalClassName={`${isInDropdown ? 'pl-2 pt-4' : 'pl-0 pr-0 pr-xl-4'}`}
                handleChange={(value) => {
                    const isSigned = value === 'SIGNED';
                    const newStatus = isSigned ? '' : value;
                    const newHasSignedContract = isSigned ? 1 : '';

                    if (isInDropdown) {
                        setFilterDropdown({
                            ...filterDropdown,
                            status: newStatus,
                            hasSignedContract: newHasSignedContract,
                        });
                    } else {
                        updateFilter('status', newStatus);
                        updateFilter('hasSignedContract', newHasSignedContract);
                        updateFilter('page', 0);
                    }
                }}
            />

            {isInDropdown && (
                <>
                    {!adminRole && (
                        <KTDropdownFilter
                            label={t('Đối tượng quản lý')}
                            filterKey="deepLevel"
                            options={DealerHelper.filterLevelOptions('INVESTOR', user?.agency?.deepLevel)}
                            selectedValue={filterDropdown.deepLevel}
                            isInDropdown={isInDropdown}
                            additionalClassName="px-2 pt-2"
                            handleChange={(value) => {
                                if (isInDropdown) {
                                    setFilterDropdown({ ...filterDropdown, deepLevel: value });
                                } else {
                                    updateFilter('deepLevel', value);
                                }
                            }}
                        />
                    )}

                    <KTDropdownFilter
                        label={t('Người tạo')}
                        filterKey="createdBy"
                        options={DealerHelper.filterCreatedByOptions()}
                        selectedValue={filterDropdown.createdBy}
                        isInDropdown={isInDropdown}
                        additionalClassName={adminRole ? 'pr-2 pt-2' : 'pl-2 pt-2'}
                        handleChange={(value) => {
                            if (isInDropdown) {
                                setFilterDropdown({ ...filterDropdown, createdBy: value });
                            } else {
                                updateFilter('createdBy', value);
                            }
                        }}
                    />

                    {adminRole && (
                        <div className="col-6 py-2 pl-2"></div>
                    )}

                    <div className="col-6 py-2 pr-2">
                        <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                            {t('Khoảng thời gian thống kê')}
                        </label>
                        <CustomDateRangePicker
                            toggleElementBorderRadius={5}
                            alignRight={true}
                            initialValue={
                                filterDropdown.selectedValue.length > 0
                                    ? filterDropdown.selectedValue
                                    : dateFilter.tatCaThoiGian
                            }
                            onPressSave={(selectedValue, startDate, endDate) => {
                                const updateFilterDropdown = {
                                    ...filterDropdown,
                                    from: startDate,
                                    to: endDate,
                                    selectedValue: selectedValue,
                                };
                                setFilterDropdown(updateFilterDropdown);
                            }}
                            filterComponent={filterDropdown}
                        />
                    </div>

                    <KTDropdownFilter
                        label='Quốc gia'
                        filterKey="country"
                        options={AgencyHelper.Data.CountryOptions}
                        selectedValue={filterDropdown.country}
                        additionalClassName="col-md-6 pl-2"
                        handleChange={(value) => {
                            setSelectedAreaProvince('');
                            setSelectedAreaDistrict('');
                            setFilterDropdown({ ...filterDropdown, country: value, areaId: '' });
                        }}
                    />

                    <KTDropdownFilter
                        label={t('city')}
                        filterKey="areaId"
                        options={areaProvinceOptions}
                        selectedOption={selectedAreaProvince}
                        selectedValue={filterDropdown.areaId}
                        isInDropdown={isInDropdown}
                        additionalClassName="pr-2 pt-2"
                        searchable={true}
                        handleChange={(value) => {
                            const province = _.find(areaProvinceList, (item) => item.areaId === value);
                            setSelectedAreaProvince(province);
                            setSelectedAreaDistrict('');
                            if (isInDropdown) {
                                setFilterDropdown({ ...filterDropdown, areaId: value });
                            } else {
                                updateFilter('areaId', value);
                            }
                        }}
                    />

                    <KTDropdownFilter
                        label={t('district')}
                        filterKey="areaId"
                        options={areaDistrictOptions}
                        selectedOption={selectedAreaDistrict}
                        selectedValue={filterDropdown.areaId}
                        isInDropdown={isInDropdown}
                        additionalClassName="pl-2 pt-2"
                        searchable={true}
                        handleChange={(value) => {
                            setSelectedAreaDistrict(
                                _.find(areaDistrictList, (item) => item.areaId === value)
                            );
                            if (isInDropdown) {
                                setFilterDropdown({ ...filterDropdown, areaId: value });
                            } else {
                                updateFilter('areaId', value);
                            }
                        }}
                    />
                </>
            )}
        </div>
    );

    return (
        <div className='m-4'>
            <KTBSCard
                borderRadius="15"
                title={t('Danh sách đối tác mua trụ sạc')}
                description={
                    <div>
                        <span className="font-weight-bolder" style={{ color: AppColors.gray[800] }}>
                            {t('total')}:{' '}
                        </span>
                        <span style={{ color: AppColors.primary }}>
                            {chargePointPartnerTotal != 0 ? chargePointPartnerTotal : chargePointPartnerList.length} {t('đối tác')}
                        </span>
                    </div>
                }
                additionalHeaderClassName="pt-4 pb-2"
                additionalBodyClassName="py-0"
                additionalFooterClassName="py-4"
                hideDividerHeader
                hideDividerFooter
                toolbar={
                    <div className="d-flex gap-3">
                        <KTBSButton
                            color={KTBSButtonColor.primary}
                            title={t('Tải xuống')}
                            size={KTBSButtonSize.default}
                            borderRadius={5}
                            buttonTitleFontWeight="600"
                            iconElement={<i className="fa-regular fa-download" style={{ fontSize: 15 }} />}
                            onPress={async () => {
                                try {
                                    ChargeHelper.UI.Excel.showDialogDownloadExcelFile(
                                        Global.g_filterChargePointPartnerList,
                                        async (params) => {
                                            try {
                                                const { agencies = [] } = await agencyApi.getAgencyList(params);
                                                return handleExportExcel(agencies, params);
                                            } catch (error) {
                                                ToastHelper.showError(`Lỗi khi lấy dữ liệu: ${error.message}`);
                                                return [];
                                            }
                                        },
                                    );
                                } catch (error) {
                                    ToastHelper.showError(`Lỗi khi khởi tạo tải xuống: ${error.message}`);
                                }
                            }}
                            height={43}
                            buttonTitleFontSize={14}
                        />
                        <KTBSButton
                            color={KTBSButtonColor.success}
                            title={t('Thêm đối tác')}
                            size={KTBSButtonSize.default}
                            borderRadius={5}
                            buttonTitleFontWeight="600"
                            iconElement={<i className="fa-regular fa-circle-plus" />}
                            onPress={handleOpenAddInvestorModal}
                        />
                    </div>
                }
                subToolbar={
                    <div className="w-100 d-flex align-items-end flex-wrap">
                        <div className={`col-lg-3 pl-0 py-2 pr-0 pr-xl-4 pr-lg-4`}>
                            <label htmlFor="search" className="mb-0 mr-2 font-weight-bolder">
                                {t('search')}
                            </label>
                            <KTFormSearch
                                name="search-bar"
                                placeholder={t('Theo mã đối tác, tên đối tác, số điện thoại, email, mã số thuế/CCCD...')}
                                value={Global.g_filterChargePointPartnerList.q}
                                onSubmit={(text) => {
                                    Global.g_filterChargePointPartnerList = {
                                        ...Global.g_filterChargePointPartnerList,
                                        q: text,
                                        page: 0,
                                    };
                                    setFilter(Global.g_filterChargePointPartnerList);
                                    setFilterDropdown(Global.g_filterChargePointPartnerList);
                                }}
                            />
                        </div>
                        <div className="col-xl-7 col-lg-9 px-0">
                            <FilterComponentList />
                        </div>

                        {/* bo loc */}
                        <div className="py-2 pr-4">
                            <DropdownFilterTable
                                filterComponent={[
                                    <div className={`${'col-12 p-0'}`}>
                                        <KTFormSearch
                                            name="search-bar"
                                            placeholder={t('Theo mã đối tác, tên đối tác, số điện thoại, email, mã số thuế/CCCD...')}
                                            value={filterDropdown.q}
                                            onSubmit={(text) => {
                                                const updateFilterDropdown = { ...filterDropdown, q: text };
                                                setFilterDropdown(updateFilterDropdown);
                                            }}
                                        />
                                    </div>,
                                    <FilterComponentList
                                        isInDropdown={true}
                                        onChange={(filter) => {
                                            setFilterDropdown({
                                                ...filterDropdown,
                                                ...filter,
                                            });
                                        }}
                                    />,
                                ]}
                                resetDefaultTable={() => {
                                    const updateFilterDropdown = {
                                        ...filterDropdown,
                                        q: '',
                                        type: '',
                                        status: '',
                                        from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
                                        to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
                                        selectedValue: dateFilter.tatCaThoiGian,
                                        areaId: '',
                                        createdBy: '',
                                        deepLevel: '',
                                        hasSignedContract: '',
                                    };
                                    setFilterDropdown(updateFilterDropdown);
                                    setFilter(updateFilterDropdown);
                                    Global.g_filterChargePointPartnerList = updateFilterDropdown;
                                    setSelectedAreaProvince('');
                                    setSelectedAreaDistrict('');
                                }}
                                saveFilter={() => {
                                    setFilter(filterDropdown);
                                    Global.g_filterChargePointPartnerList = filterDropdown;
                                }}
                                isDefaultFilter={Utils.checkDefaultFilter(
                                    ['role', 'page', 'limit', 'from', 'to', 'selectedValue'],
                                    filter
                                )}
                            />
                        </div>
                        {/* cau hinh cot */}
                        <div className="pr-0 py-2">
                            <DropdownTableConfigColumn
                                columnIds={columnIds}
                                fullColumns={fullColumns}
                                fullColumnIds={fullColumnsIdSorted}
                                onChangeCheckboxValue={onChangeCheckboxValue}
                                saveChanges={saveChanges}
                                resetDefaultTableColumn={() => {
                                    setFullColumnIds(defaultColumnIds);
                                    resetDefaultTableColumn();
                                }}
                                onChangeFullColumnIds={(ids) => {
                                    setFullColumnIds(ids);
                                    const key = prefKey + '_FULL_COLUMN_IDS';
                                    localStorage.setItem(key, ids.join('|'));
                                }}
                                onSelectAll={onSelectAll}
                                onUnSelectAll={onUnSelectAll}
                            />
                        </div>
                    </div>
                }
                footer={
                    <KTPagination
                        currentPage={filter.page + 1}
                        rowCount={chargePointPartnerTotal != 0 ? chargePointPartnerTotal : chargePointPartnerList.length}
                        rowsPerPage={filter.limit}
                        currentItemInPageCount={chargePointPartnerList.length}
                        onChangePage={(newPage) => {
                            const iNewPage = parseInt(newPage);
                            Global.g_filterChargePointPartnerList = {
                                ...Global.g_filterChargePointPartnerList,
                                page: iNewPage - 1,
                            };
                            setFilter(Global.g_filterChargePointPartnerList);
                        }}
                        onChangeRowsPerPage={(newRowsPerPage) => {
                            const iNewRowsPerPage = parseInt(newRowsPerPage);
                            Global.g_filterChargePointPartnerList = {
                                ...Global.g_filterChargePointPartnerList,
                                limit: iNewRowsPerPage,
                                page: 0,
                            };
                            setFilter(Global.g_filterChargePointPartnerList);
                        }}
                        loading={isGettingData}
                        color={KTPaginationColor.success}
                        appendText="đối tác"
                    />
                }
                body={
                    <KTTable
                        columns={columns}
                        items={chargePointPartnerList}
                        selectableRows={false}
                        striped={false}
                        hasActionColumn={true}
                        compactGrid={false}
                        onClickedRow={(row) => {
                            //console.log('row', row);
                        }}
                        onSelectedRowsChanged={(rows) => { }}
                        onDoubleClickedRow={(rows) => { }}
                        noDataComponent={
                            <EmptyView
                                icon={imgEmptyNoData}
                                title="Không có dữ liệu để hiển thị"
                                text={<span span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
                            />
                        }
                    />
                }
            />
        </div>
    );
}

export default ChargePointPartnerListScreen;
